import { render, staticRenderFns } from "./purchase-view.vue?vue&type=template&id=9049339a&scoped=true&"
import script from "./purchase-view.vue?vue&type=script&lang=ts&"
export * from "./purchase-view.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-view.vue?vue&type=style&index=0&id=9049339a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9049339a",
  null
  
)

export default component.exports